import {
  CategoriesListType,
  CoinRangeType,
  FiltersStateType,
  LocationType,
  OfferStatus,
  initialFiltersState,
} from '~contexts'

export const dispatchType = {
  RESET_FILTERS: 'reset_filters',
  SET_INITIAL_STATE: 'update_initial_state',
  UPDATE_CATEGORIES_LIST: 'update_categories_list',
  UPDATE_COIN_RANGE: 'update_coin_range',
  UPDATE_SELECTED_LOCATION: 'update_selected_location',
  UPDATE_SELECTED_OFFER_STATUS: 'update_selected_offer_status',
} as const

export type ActionType =
  | {
      type: typeof dispatchType.RESET_FILTERS
    }
  | {
      type: typeof dispatchType.UPDATE_CATEGORIES_LIST
      payload: CategoriesListType
    }
  | {
      type: typeof dispatchType.UPDATE_COIN_RANGE
      payload: CoinRangeType
    }
  | {
      type: typeof dispatchType.UPDATE_SELECTED_LOCATION
      payload: LocationType
    }
  | {
      type: typeof dispatchType.UPDATE_SELECTED_OFFER_STATUS
      payload: OfferStatus
    }
  | {
      type: typeof dispatchType.SET_INITIAL_STATE
      payload: FiltersStateType
    }
export const filtersReducer = (prevState: FiltersStateType, action: ActionType) => {
  switch (action.type) {
    case dispatchType.RESET_FILTERS:
      return initialFiltersState
    case dispatchType.SET_INITIAL_STATE:
      return action.payload
    case dispatchType.UPDATE_CATEGORIES_LIST:
      return { ...prevState, categoriesList: action.payload }
    case dispatchType.UPDATE_COIN_RANGE:
      return { ...prevState, coinRange: action.payload }
    case dispatchType.UPDATE_SELECTED_LOCATION:
      return { ...prevState, selectedLocation: action.payload }
    case dispatchType.UPDATE_SELECTED_OFFER_STATUS:
      return { ...prevState, selectedOfferStatus: action.payload }
    default:
      throw new Error()
  }
}
